// extracted by mini-css-extract-plugin
module.exports = {"form-append-btn":"_15Rq5at6"};